var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHardCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2134 7.66339C11.2134 8.36248 10.6453 8.93135 9.94715 8.93135H3.68445C3.308 8.93135 3 8.62293 3 8.24596L3 5.52906C3 4.13088 4.12934 3 5.52562 3H10.5768C10.9328 3 11.2134 3.28101 11.2134 3.63055L11.2134 7.66339Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10677 16C6.33336 16 5.70639 15.3669 5.70639 14.586C5.70639 13.8051 6.33336 13.172 7.10677 13.172C7.88019 13.172 8.50716 13.8051 8.50716 14.586C8.50716 15.3669 7.88019 16 7.10677 16Z",
    fill: "#FBA12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8818 16C12.1084 16 11.4814 15.3669 11.4814 14.586C11.4814 13.8051 12.1084 13.172 12.8818 13.172C13.6552 13.172 14.2822 13.8051 14.2822 14.586C14.2822 15.3669 13.6552 16 12.8818 16Z",
    fill: "#FBA12B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.4656V8.93154C17 7.16452 15.1347 4.5 13.6227 4.5H13.0347C12.6497 4.5 12.3347 4.81806 12.3347 5.20681V8.57814C12.3347 9.55353 11.316 10.1101 10.35 10.1101H3.70008C3.31508 10.1101 3.00008 10.6632 3.00008 11.052V12.4656C3.00008 13.5791 3.70697 14.489 4.77234 14.5787C4.77623 13.2803 5.81985 12.2289 7.10666 12.2289C8.39588 12.2289 9.44099 13.2842 9.44099 14.586H10.5473C10.5473 13.2842 11.5925 12.2289 12.8817 12.2289C14.169 12.2289 15.2129 13.2811 15.216 14.5801C16.2908 14.4991 17 13.5854 17 12.4656Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHardCopy);
export default __webpack_public_path__ + "static/media/order-hard-copy.e003e8d1f42ba019aed852d18b7061cc.svg";
export { ForwardRef as ReactComponent };